var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2WorkshopBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.82 36l.43-.06C67.93 35.5 70 32.79 70 29.5c0-3.59-2.46-6.5-5.5-6.5H42.94L36 26.58V37.9l6.23 2.88 5 7.22h8l2.87 10.23a4.93 4.93 0 006 3.36 4.83 4.83 0 003.36-6l-4.8-17.05A2.26 2.26 0 0164.82 36zm-15.51 8l-2.07-3h6.06l.83 3h-4.82zM24 26h7v12h-7l-4-4H4v-4h16l4-4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Workshop_bis.6bcc4144.svg";
export { SvgE2WorkshopBis as ReactComponent };